import './ProductCard.css'
import { Link } from 'react-router-dom'
import { HeartIcon } from './Icons'
import { useCart } from '../context/CartContext'
import { imageSrc } from '../services/api'

export const inr = n => `₹${Number(n).toLocaleString('en-IN')}`

// Rebuilds an uploaded image address from its /uploads/... part, so a wrong host saved by the server
// (for example http://localhost:5000) can never break images on phones or other devices.
const fixUrl = u => { const m = String(u).match(/(\/uploads\/[^?#]+)/); return m ? imageSrc(m[1]) : u }

// every image of a product, main one first (falls back to the single `image`)
export const gallery = p => {
  let list = p.images
  if (typeof list === 'string') { try { list = JSON.parse(list) } catch { list = null } }
  if (Array.isArray(list) && list.length) return list.filter(Boolean).map(fixUrl)
  const one = p.image || p.image_url
  return one ? [fixUrl(one)] : []
}

// the price to charge, the crossed-out old price and the % off.
// A sale only counts when the sale price is really lower than the normal price.
export const pricing = p => {
  const price = Number(p.price) || 0
  const sale = Number(p.salePrice ?? p.sale_price)
  if (sale > 0 && sale < price) return { price: sale, was: price, pct: Math.round((1 - sale / price) * 100) }
  return { price, was: null, pct: 0 }
}

// 'in' (can be bought), 'out' (out of stock) or 'soon' (coming soon). Set from Admin > Products > Stock status.
export const stock = p => {
  const s = String(p.status ?? p.stock_status ?? '').toLowerCase()
  if (s.startsWith('out')) return 'out'
  if (s.startsWith('coming')) return 'soon'
  return 'in'
}
export const STOCK_LABEL = { out: 'Out of stock', soon: 'Coming soon' }

export default function ProductCard({ p }) {
  const { wish, toggleWish } = useCart()
  const on = wish.includes(p.id)
  const hue = p.hue ?? 210
  const imgs = gallery(p)
  const { price, was, pct } = pricing(p)
  const st = stock(p)
  return (
    <article className={`pcard${st !== 'in' ? ' pcard--off' : ''}`}>
      <Link to={`/product/${p.id}`} className="pcard__img" aria-label={p.name}
        style={{ background: `linear-gradient(145deg, hsl(${hue} 35% 94%), hsl(${hue} 45% 80%))` }}>
        {imgs[0] ? <img src={imgs[0]} alt="" loading="lazy" /> : <span>{p.category}</span>}
        {imgs[1] && <img className="pcard__alt" src={imgs[1]} alt="" loading="lazy" />}
        {(st !== 'in' || pct > 0 || p.isNew || p.best) && (
          <span className="pcard__badges">
            {st !== 'in' && <em className={`pcard__badge pcard__badge--${st}`}>{STOCK_LABEL[st]}</em>}
            {pct > 0 && <em className="pcard__badge pcard__badge--sale">{pct}% OFF</em>}
            {p.isNew && <em className="pcard__badge">NEW</em>}
            {p.best && !p.isNew && <em className="pcard__badge pcard__badge--best">BEST SELLER</em>}
          </span>
        )}
      </Link>
      <button className="pcard__heart" onClick={() => toggleWish(p.id)} aria-pressed={on} aria-label={on ? 'Remove from wishlist' : 'Add to wishlist'}><HeartIcon filled={on} size={18} /></button>
      <Link to={`/product/${p.id}`}><h3>{p.name}</h3></Link>
      <p className="pcard__price">
        {p.models ? 'From ' : ''}
        <span className={was ? 'pcard__now' : undefined}>{inr(price)}</span>
        {was && <s className="pcard__was">{inr(was)}</s>}
      </p>
    </article>
  )
}